module.exports = __webpack_public_path__ + "img/shirt.959918c.svg";